import { render, staticRenderFns } from "./ConfirmHeader.vue?vue&type=template&id=08d61170&scoped=true&"
import script from "./ConfirmHeader.vue?vue&type=script&lang=js&"
export * from "./ConfirmHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d61170",
  null
  
)

export default component.exports